class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.querySelector('select').addEventListener('change', this.onSelectChange.bind(this));
  }

  onSelectChange(event) {
    const currentTarget = event.currentTarget;
    const hiddenSelectedOption = this.querySelector('.localization-form-value');
    hiddenSelectedOption.textContent = currentTarget.options[currentTarget.selectedIndex].textContent;
    const input = this.querySelector('input[name="country_code"], input[name="language_code"]');
    input.value = currentTarget.value;
    this.querySelector('form').submit();
  }
}

customElements.define('localization-form', LocalizationForm);
